import { render, staticRenderFns } from "./GlobalIntegrationTime.vue?vue&type=template&id=88032ed4"
import script from "./GlobalIntegrationTime.vue?vue&type=script&lang=js"
export * from "./GlobalIntegrationTime.vue?vue&type=script&lang=js"
import style0 from "./GlobalIntegrationTime.vue?vue&type=style&index=0&id=88032ed4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports